import DetailReception from './DetailReception.jsx';
export {
  DetailReception
};



// WEBPACK FOOTER //
// ./src/components/modules/reception-periodical/popup-detail/index.js